export const BREAK_LARGE_RESOLUTION = 710;
